import { REACT_APP__YANDEX_METRIKA_COUNTER } from "@smp/utils";

type ReachGoalEvent =
  | "signup"
  | "email_verify"
  | "account_credentials_connect"
  | "post_scheduled_sc"
  | "post_scheduled_old_form"
  | "post_scheduled_new_form"
  | "ai_write_text"
  | "ai_chat"
  | "ai_rewrite_text"
  | "ai_write_plan"
  | "ai_schedule_post"
  | "ai_save_chat"
  | "ai_retry_request"
  | "ai_copy_answer"
  | "ai_post_idea"
  | "ai_video_script"
  | "ai_video_idea"
  | "ai_story_game_idea"
  | "ai_write_quiz"
  | "ai_write_article_title"
  | "ai_write_article_outline"
  | "ai_write_intro_paragraph"
  | "ai_write_few_paragraphs"
  | "ai_write_post_from_draft"
  | "ai_typograf"
  | "ai_write_final_paragraph"
  | "ai_write_post_from_outline"
  | "ai_write_text_summary"
  | "ai_write_cold_email"
  | "ai_write_editors_advice"
  | "ai_upscale_photo"
  | "navigation_reports"
  | "open_report"
  | "header_billing_button"
  | "post_scheduled_form_v3"
  | "dashboard_go_to_sc"
  | "dashboard_go_to_pc"
  | "dashboard_go_to_polotno_designs"
  | "dashboard_go_to_polotno_templates"
  | "dashboard_go_to_ai_chat"
  | "dashboard_go_to_ai_write_text"
  | "advisor_open"
  | "payment"
  | "image_ai_generated"
  | "gpt_agent_create"
  | "gpt_agent_update"
  | "advisor_click_generate_posts"
  | "polotno_templates_search"
  | "post_scheduled"
  | "story_scheduled";

export const yaReachGoal = (
  event: ReachGoalEvent,
  params?: Record<string, string | number | boolean>,
  once?: boolean,
) => {
  const sessionStorageKey = `ep_ya_reach_goal__${event}`;

  let resultEvent: string | undefined = event;
  let resultParams = params;

  if (once) {
    if (typeof window !== "undefined") {
      if (sessionStorage.getItem(sessionStorageKey)) {
        return;
      } else {
        sessionStorage.setItem(sessionStorageKey, "1");
      }
    }
  }

  if (event === "open_report") {
    const medium = params?.medium;

    resultEvent = medium ? event + "_" + medium : undefined;
    resultParams = undefined;
  }

  if (window.ym && REACT_APP__YANDEX_METRIKA_COUNTER) {
    window.ym(
      REACT_APP__YANDEX_METRIKA_COUNTER,
      "reachGoal",
      resultEvent,
      resultParams,
    );
  } else {
    console.log(
      `%c reachGoal event: "${resultEvent}" params: ${JSON.stringify(
        resultParams,
      )}`,
      "background: #222; color: #bada55",
    );
  }
};
